const cookieMaxAgeSeconds = 31536000;

function isSecureContext(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

export function readCookie(name: string): string | null {
  // Browsers expose cookie names unencoded, so match the raw name (e.g. the legacy
  // `_immortal|mutiny.user.token` cookie, whose `|` would otherwise be percent-encoded and never hit).
  const prefix = `${name}=`;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmedPart = part.trim();
    if (trimmedPart.startsWith(prefix)) {
      try {
        return decodeURIComponent(trimmedPart.slice(prefix.length));
      } catch {
        // A malformed percent-escape must not crash tracker init; treat the value as absent.
        return null;
      }
    }
  }
  return null;
}

export function writeCookie(name: string, value: string): void {
  const secureAttr = isSecureContext() ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${cookieMaxAgeSeconds}; Path=/; SameSite=Lax${secureAttr}`;
}

export function deleteCookie(name: string): void {
  const secureAttr = isSecureContext() ? '; Secure' : '';
  document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax${secureAttr}`;
}
